module.exports = __webpack_public_path__ + "img/hf_fake_map_overlay.svg";